import { Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import Api from '../../../Apis/api.service'
import CircularProgressWithLabel from '../../circular_progress'
import { MultiColorProgressBar } from '.'

const buildVotesReadings = (record) => {
  return [
    {
      position: 0,
      title: 'Pour',
      value: record.tantiemes_pour,
      percent: record.tantiemes_pour_percent,
      count: record.coproprietaires_pour,
      color: '#198754',
    },
    {
      position: 1,
      title: 'Abstention',
      value: record.tantiemes_abstention,
      percent: record.tantiemes_abstention_percent,
      count: record.coproprietaires_abstention,
      color: '#ffc107',
    },

    {
      position: 2,
      title: 'Contre',
      value: record.tantiemes_contre,
      percent: record.tantiemes_contre_percent,
      count: record.coproprietaires_contre,
      color: '#dc3545',
    },

    {
      position: 3,
      title: 'Sans vote',
      value: record.tantiemes_sansvote,
      percent: record.tantiemes_sansvote_percent,
      count: record.coproprietaires_sansvote,
      color: '#6c757d',
    },
  ]
}

export const VoteProgress = ({ lastRefreshTime, isChanged, ...props }) => {
  const [progress, setProgress] = useState(0)
  const [readings, setReadings] = useState([])
  const [shouldRefreshVotes, setShouldRefreshVotes] = useState(
    props.record.opened === true && props.record.vote_progress < 100
  )
  const record = props.record
  let timer = null

  const fetchProgress = async () => {
    const res = await Api.resolutions.getOneResolution(record.id)

    if (res.status === 200) {
      const { data } = res
      setProgress(data.vote_progress)
      let r = buildVotesReadings(data)
      setReadings(r)
    } else {
      window.clearInterval(timer)
    }
  }

  useEffect(() => {
    fetchProgress()
    timer = setInterval(() => {
      fetchProgress()
    }, 3600)

    return () => {
      window.clearInterval(timer)
    }
  }, [shouldRefreshVotes, isChanged])

  if (!record.opened) return null

  return (
    <Grid container xs={12}>
      <Grid item>
        <MultiColorProgressBar readings={readings} />
      </Grid>
      <Grid item style={{ marginLeft: '0.3em' }}>
        <CircularProgressWithLabel value={progress} />
      </Grid>
    </Grid>
  )
}
export default VoteProgress
